export const MAIN_API_BASE_URL = 'https://norma.education-services.ru/api'
export const INGREDIENTS_API = 'https://my-json-server.typicode.com/naumch1k/stellar-burgers'
export const WS_BASE_URL = 'wss://norma.nomoreparties.space/orders'

export const ACCESS_TOKEN_KEY = 'accessToken'
export const REFRESH_TOKEN_KEY = 'refreshToken'
